import "@formatjs/intl-pluralrules/polyfill";
import "@formatjs/intl-pluralrules/locale-data/bg";
import "@formatjs/intl-pluralrules/locale-data/cs";
import "@formatjs/intl-pluralrules/locale-data/da";
import "@formatjs/intl-pluralrules/locale-data/de";
import "@formatjs/intl-pluralrules/locale-data/el";
import "@formatjs/intl-pluralrules/locale-data/en";
import "@formatjs/intl-pluralrules/locale-data/es";
import "@formatjs/intl-pluralrules/locale-data/et";
import "@formatjs/intl-pluralrules/locale-data/fi";
import "@formatjs/intl-pluralrules/locale-data/fr";
import "@formatjs/intl-pluralrules/locale-data/hr";
import "@formatjs/intl-pluralrules/locale-data/hu";
import "@formatjs/intl-pluralrules/locale-data/it";
import "@formatjs/intl-pluralrules/locale-data/lt";
import "@formatjs/intl-pluralrules/locale-data/lv";
import "@formatjs/intl-pluralrules/locale-data/nb";
import "@formatjs/intl-pluralrules/locale-data/nl";
import "@formatjs/intl-pluralrules/locale-data/no";
import "@formatjs/intl-pluralrules/locale-data/pl";
import "@formatjs/intl-pluralrules/locale-data/pt";
import "@formatjs/intl-pluralrules/locale-data/ro";
import "@formatjs/intl-pluralrules/locale-data/sk";
import "@formatjs/intl-pluralrules/locale-data/sl";
import "@formatjs/intl-pluralrules/locale-data/sv";
import messagesEN from './tachographservices_en-GB.json';
export const defaultMessages = messagesEN;
export const DEFAULT_LANGUAGE = 'en-GB';
export const SUPPORTED_LANGUAGES = {
    en: 'en-GB',
    'en-GB': 'en-GB',
    'en-US': 'en-GB',
    de: 'de-DE',
    'de-DE': 'de-DE',
    cs: 'cs-CZ',
    'cs-CZ': 'cs-CZ',
    da: 'da-DK',
    'da-DK': 'da-DK',
    es: 'es-ES',
    'es-ES': 'es-ES',
    fr: 'fr-FR',
    'fr-FR': 'fr-FR',
    it: 'it-IT',
    'it-IT': 'it-IT',
    nl: 'nl-NL',
    'nl-NL': 'nl-NL',
    pl: 'pl-PL',
    'pl-PL': 'pl-PL',
    ro: 'ro-RO',
    'ro-RO': 'ro-RO',
    bg: 'bg-BG',
    'bg-BG': 'bg-BG',
    hr: 'hr-HR',
    'hr-HR': 'hr-HR',
    fi: 'fi-FI',
    'fi-FI': 'fi-FI',
    hu: 'hu-HU',
    'hu-HU': 'hu-HU',
    lt: 'lt-LT',
    'lt-LT': 'lt-LT',
    nb: 'nb-NO',
    'nb-NO': 'nb-NO',
    pt: 'pt-PT',
    'pt-PT': 'pt-PT',
    sk: 'sk-SK',
    'sk-SK': 'sk-SK',
    sl: 'sl-SI',
    'sl-SI': 'sl-SI',
    'sl-SL': 'sl-SI',
    se: 'sv-SE',
    'sv-SE': 'sv-SE',
    el: 'el-GR',
    'el-GR': 'el-GR',
    et: 'et-EE',
    'et-EE': 'et-EE',
    lv: 'lv-LV',
    'lv-LV': 'lv-LV',
};
/* istanbul ignore next */
const browserLocale = navigator.language || DEFAULT_LANGUAGE;
export const getSupportedLanguageKey = (
// istanbul ignore next
languageKey = navigator.language) => {
    // istanbul ignore next
    if (languageKey !== null) {
        const langKeyShort = languageKey.split('-')[0];
        if (SUPPORTED_LANGUAGES[languageKey]) {
            return SUPPORTED_LANGUAGES[languageKey];
        }
        else if (SUPPORTED_LANGUAGES[langKeyShort]) {
            return SUPPORTED_LANGUAGES[langKeyShort];
        }
    }
    // istanbul ignore next
    const browserLocaleShort = browserLocale.split('-')[0];
    // istanbul ignore next
    if (SUPPORTED_LANGUAGES[browserLocale]) {
        return SUPPORTED_LANGUAGES[browserLocale];
    }
    else if (SUPPORTED_LANGUAGES[browserLocaleShort]) {
        return SUPPORTED_LANGUAGES[browserLocaleShort];
    }
    // istanbul ignore next
    return DEFAULT_LANGUAGE;
};

const momentLocaleImports = {
    bg: () => import('moment/dist/locale/bg'),
    cs: () => import('moment/dist/locale/cs'),
    da: () => import('moment/dist/locale/da'),
    de: () => import('moment/dist/locale/de'),
    'en-gb': () => import('moment/dist/locale/en-gb'),
    el: () => import('moment/dist/locale/el'),
    es: () => import('moment/dist/locale/es'),
    et: () => import('moment/dist/locale/et'),
    fi: () => import('moment/dist/locale/fi'),
    fi: () => import('moment/dist/locale/fi'),
    fr: () => import('moment/dist/locale/fr'),
    hr: () => import('moment/dist/locale/hr'),
    hu: () => import('moment/dist/locale/hu'),
    it: () => import('moment/dist/locale/it'),
    ko: () => import('moment/dist/locale/ko'),
    lt: () => import('moment/dist/locale/lt'),
    lv: () => import('moment/dist/locale/lv'),
    nb: () => import('moment/dist/locale/nb'),
    nl: () => import('moment/dist/locale/nl'),
    pl: () => import('moment/dist/locale/pl'),
    pt: () => import('moment/dist/locale/pt'),
    'pt-br': () => import('moment/dist/locale/pt-br'),
    ro: () => import('moment/dist/locale/ro'),
    sk: () => import('moment/dist/locale/sk'),
    sl: () => import('moment/dist/locale/sl'),
    sv: () => import('moment/dist/locale/sv'),
};

export const getMomentLocale = (locale) => {
    if (locale.toLowerCase() === 'pt-br') {
        return 'pt-br';
    } else {
        const countryCode = locale.substring(0, 2);
        if (countryCode === 'en') {
            return 'en-gb';
        } else {
            return countryCode;
        }
    }
};

export const importLocale = async (locale) => {
    if (momentLocaleImports[locale]) {
        await momentLocaleImports[locale]();
    } else {
        throw new Error(`momentLocale of country ${locale} could not be imported`);
    }
};
